import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"application",attrs:{"oncontextmenu":"return false;"}},[_c(VMain,{staticStyle:{"background-color":"#FCFCFC","height":"100vh"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }